import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RecommendationPicture } from '../dto/recommendation-picture';

@Injectable({
  providedIn: 'root'
})
export class RecommendationPictureService {

  private apiUrl = environment.apiRoot + '/recommendationpicture';
    
  constructor(private http : HttpClient) { }

  getAllPicturesOfRecommendation(testId: number) : Observable<RecommendationPicture[]> {
    return this.http.get<RecommendationPicture[]>(this.apiUrl + '/allofrecommendation?recommendationId=' + testId); 
  }

  getRecommendationPicture(recommendationPictureId: number) : Observable<ArrayBuffer> {
    return this.http.get(this.apiUrl + '/picture?&recommendationPictureId=' + recommendationPictureId, {responseType: 'arraybuffer'});
  }

  fileUpload(recommendationId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    return this.http.post(this.apiUrl + '/fileupload?recommendationId=' + recommendationId, formData);
  }

  deleteRecommendationPicture(recommendationPictureId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?recommendationPictureId=' + recommendationPictureId);
  }
}
